module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chap",
    attrs: {
      "epub:type": "chapter",
      "id": "chap-001"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_29",
      "title": "29"
    }
  }, [_c('div', {
    staticClass: "chap_debut"
  }), _c('h1', {
    staticClass: "chap_surtit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_c('img', {
    staticClass: "imagelarge_intext",
    attrs: {
      "alt": "",
      "id": "chap2",
      "src": "images/chap2.jpg"
    }
  })])]), _c('h1', {
    staticClass: "chap_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("Exposing Common Myths"), _c('br'), _vm._v("About Unchurched Americans")])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('span', {
    staticClass: "let"
  }, [_vm._v("T")]), _vm._v("here are few things we like more than a startling statistic. Something eye-popping that will alarm us, make us laugh, or prove a point. Nothing helps create an enduring narrative in our culture faster than a statistic that can captivate our imagination. Sadly, this often leads us to latch onto false statistics and quickly pass them on to others. These false statistics and the accompanying narratives, or myths, are nearly impossible to root out, and even today many still believe they’re true. Consider these myths you might have heard or even passed on:")]), _c('ul', {
    staticClass: "liste_puce"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_c('i', [_vm._v("Myth 1: Women over forty with a university degree are more likely to be killed by terrorists than get married. ")]), _vm._v("The cause? A "), _c('i', [_vm._v("Newsweek")]), _vm._v(" cover in June 1986 declared an impending “marriage crunch,” highlighted by the fact that women over forty had only a 2.6 percent chance of getting married."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntf-016",
      "id": "ap_ntf-016-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" The story was so bad and discredited so thoroughly by scholars that "), _c('i', [_vm._v("Newsweek")]), _vm._v(" went so far as to retract it twenty years later."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntf-017",
      "id": "ap_ntf-017-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" That didn’t mean the myth wasn’t popular as it was so enduring in American life that it was featured in the popular movie "), _c('i', [_vm._v("Sleepless in Seattle ")]), _vm._v("in which two characters argue over whether it is true.")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_30",
      "title": "30"
    }
  }, [_c('i', [_vm._v("Myth 2: Your soul weighs twenty-one grams on average.")]), _vm._v(" This outlandish figure was first postulated by Dr. Duncan MacDougall of Haverhill, Massachusetts, in 1907. To support his thesis, MacDougall simply weighed terminally ill patients just before and then immediately after they died."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntf-018",
      "id": "ap_ntf-018-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" It was widely considered to be proof of the existence of the soul.")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_c('i', [_vm._v("Myth 3: We use only 10 percent of our brains, and if we could just use our whole brains we could tap into untold powers (e.g., extrasensory perception, telekinesis, and advanced intelligence).")]), _vm._v(" This myth is so old and widespread that researchers are not even sure where it originated."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntf-019",
      "id": "ap_ntf-019-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" Despite the best efforts of scientists to kill this myth, it has given rise to a whole cottage industry of science fiction books and television programs.")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_c('i', [_vm._v("Myth 4: One in five kids has been approached by a sexual predator via the internet")]), _vm._v(". This statistic was reported in a 2000 study issued by the National Center for Missing and Exploited Children."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntf-020",
      "id": "ap_ntf-020-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" It pointed to an alarming crisis, especially in light of the amount of internet usage by American kids.")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_c('i', [_vm._v("Myth 5: In America alone, about 150,000 teens die of anorexia nervosa each year")]), _vm._v(". This alarming statistic was reported in many feminist-authored books exploring the challenges of teen girls, notably in Naomi Wolf’s bestseller "), _c('i', [_vm._v("The Beauty Myth")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntf-021",
      "id": "ap_ntf-021-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("So what do all these myths have in common? To begin with, they are usually started by or at least cited by a credible news source. Because of this credibility boost, people implicitly accept the statistic and begin to share it widely. Over time, as this myth is repeated as reality across countless blogs, books and articles, it becomes common knowledge. At this point, it is nearly impossible for experts to set the record straight.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The truth?")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Educated women over forty have a significantly higher chance of getting married than being killed by a terrorist, the chances of which are a tiny "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_31",
      "title": "31"
    }
  }, [_vm._v("0.002 percent."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntf-022",
      "id": "ap_ntf-022-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" While the soul’s weight is indeterminate, MacDougall’s methodology in arriving at his twenty-one grams was laughably deficient."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntf-023",
      "id": "ap_ntf-023-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" Scientists agree that we use 100 percent of the brain, supported by new technologies in brain mapping that show no inactive parts."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntf-024",
      "id": "ap_ntf-024-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" Although one in five kids annually receive unwanted online sexual solicitation, usually by a friend being suggestive, the report in question goes on to say that only one in four of those solicited received a solicitation that left them very upset or afraid."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntf-025",
      "id": "ap_ntf-025-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" While distressing incidents should not be minimized, headlines using the statistic glossed over important degrees of severity among these incidents to overemphasize worst-case scenarios. The American Anorexia and Bulimia Association confirms that it is actually 150,000 who "), _c('i', [_vm._v("suffer ")]), _vm._v("from anorexia rather than die from it annually."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntf-026",
      "id": "ap_ntf-026-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Before any fingers get pointed, though, Christians love using bad statistics too! In his article “Evangelicals Behaving Badly with Statistics,” Notre Dame sociologist Christian Smith argues,")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("American evangelicals, who profess to be committed to Truth, are among the worst abusers of simple descriptive statistics, which claim to represent the truth about reality, of any group I have ever seen. At stake in this misuse are evangelicals’ own integrity, credibility with outsiders, and effectiveness in the world. It is an issue worth making a fuss over."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntf-027",
      "id": "ap_ntf-027-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Summarizing and building on Smith’s conclusion, Ed Stetzer helpfully reflects, “Evangelical leaders and organizations routinely use descriptive statistics in sloppy, unwarranted, misrepresenting, and sometimes absolutely preposterous ways.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntf-028",
      "id": "ap_ntf-028-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("But why? Why do evangelicals fall prey to false statistics when the truth of the gospel is already compelling? Just like society around us, many evangelicals simply like to create alarm to sell books and influence people. The more dire the crisis, the more likely people will pay attention, read an article, buy a book, or attend a conference. The more "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_32",
      "title": "32"
    }
  }, [_vm._v("drama we can generate by scaring people, the more people will be willing to do something about it.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("But there are hidden costs to our misuse of statistics. To illustrate the severity of these costs and the danger they present to the church, we need look no further than the story of Chicken Little.")]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-008"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Chicken Little Syndrome")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("In the story of Chicken Little, an acorn falls on the head of a young chicken, causing him to panic, feeling that the sky itself is falling."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntf-029",
      "id": "ap_ntf-029-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" Armed with this mistaken myth, Chicken Little sets off to systematically convince his friends that the world is ending. Each friend agrees to join the mission until eventually they meet Foxy Loxy. The fox promises Chicken Little and his friends that they can be safe in his den. Foolishly, the group enters the fox’s den, never to be seen again. The fable ends with the point that all went wrong because of the foolish fright of Chicken Little.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Today few people have never heard of the story of Chicken Little or its moral about unjustified fear. In fact, "), _c('i', [_vm._v("Merriam-Webster")]), _vm._v(" defines Chicken Little as “one who warns of or predicts calamity, especially without justification” and tracks its first recorded usage to 1895."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntf-030",
      "id": "ap_ntf-030-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" It has become so ingrained in our lives that the phrase “the sky is falling” has become a common way to describe people who imagine or exaggerate an impending catastrophe. Scholars describe the results of fear mongering as Chicken Little Syndrome, in which near-apocalyptic warnings drive people to either crippling fear or disastrous action."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntf-031",
      "id": "ap_ntf-031-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" One scholar provides a helpful definition as “a sense of despair or passivity which blocks the audience from actions.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntf-032",
      "id": "ap_ntf-032-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" The term began appearing in the 1950s."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntf-033",
      "id": "ap_ntf-033-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In other words, disproportionate alarm can cause panic, misguided actions, passivity, withdrawal, a sense of powerlessness, and even disaster through the power of self-fulfilling prophecy. When we misread reality, we can apply inappropriate solutions to problems we have inflated, or we can withdraw from the field of action entirely. Great leadership starts "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_33",
      "title": "33"
    }
  }, [_vm._v("with a good description of the reality we are trying to address and change, and alarmist and misleading statistics are therefore not good leadership.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("When it comes to researching and reporting on the present state of faith in America and the attitude of most Americans toward the church, too many have fallen victim to Chicken Little Syndrome. We are too quick to listen to the voices proclaiming, “The sky is falling!” by overstating the decline and even near-term disappearance of the church in America. Just like Chicken Little’s friends, we hear the alarm and apocalyptic language, buoyed by suspect statistics, and in our fear we buy their books and attend their conferences. In doing so, we inadvertently reinforce alarm instead of action, passivity instead of proclamation, and defeatism instead of hope.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In light of these dire warnings, many Christians have stopped sharing our faith, inviting people to church, and expecting God to convert many and renew the church in our time. A recent Barna study reports that three-fourths of self-identified Christians who have had a conversation about their faith have fewer than ten spiritual conversations a year."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntf-034",
      "id": "ap_ntf-034-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" That’s less than one spiritual conversation per month. On top of that—or perhaps at the heart of it—48 percent of Christians say that most non-Christians have no interest in hearing about Jesus."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntf-035",
      "id": "ap_ntf-035-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" No wonder there aren’t more Christians sharing their faith. It’s difficult to offer good news to people if we’re already convinced that they won’t think it’s good and that we will offend people and push them even further away if we are bold and direct about our faith.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The sad truth is that the American church has fostered Chicken Little Syndrome for several decades, and we are now confronting the negative consequences. Some have withdrawn into separate enclaves, suspicious of outsiders."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntf-036",
      "id": "ap_ntf-036-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" Our narrative has led to many people in churches becoming pessimistic about their witness and their future, which has given direction and legitimacy to their passivity. If this is going to change, we need to root out the mistaken myths that "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_34",
      "title": "34"
    }
  }, [_vm._v("Christians tell ourselves about the state of the church, replacing them with truth that gets us on mission for the gospel in our communities.")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-009"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("American Church Myths Exposed")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("So what are the false statistics that have created mistaken myths in the church? I use the phrase “mistaken myths” because myths are not always false. They can sometimes reflect and point to foundational realities like the best mythic tales often do, or alternatively they can create distorted pictures of reality and generate false narratives. What half-truths and alarming statistics do we regularly cite that reinforce a misleading cultural narrative about faith and the church in America?")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Warning: difficult content ahead. Many of the statistics I list you may have had shared with you or—gasp!—you may have passed on. This is not an attempt to point the finger but rather to right the ship. All of us have contributed to the problem at one time or another. In the spirit of charity and knowing that our united goal is the advancement of Christ’s kingdom, we need to rightly engage the serious issues we face in the church, and this begins with an accurate picture of reality.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In the rest of this chapter, I will explore four central mistaken myths about the American church and the misleading statistics that continue to breathe life into them.")]), _c('ul', {
    staticClass: "liste_puce"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_c('i', [_vm._v("Myth 1: America is becoming non- or anti-Christian, “a nation of nones,” those who have no allegiance to any particular religion or religious body.")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_c('i', [_vm._v("Myth 2: Millennials are leaving the church at an alarmingly high rate and rarely, if ever, returning.")]), _vm._v(" Church has become irrelevant to the emerging generation.")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_c('i', [_vm._v("Myth 3: The church is dwindling in America and will disappear in a generation.")]), _vm._v(" The church has been on a decades-long free fall to the point of impending near-extinction.")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_c('i', [_vm._v("Myth 4: Trust in the church is at an all-time low as fewer Americans have a history of church involvement, and those who do often define "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_35",
      "title": "35"
    }
  }, [_vm._v("their experience as negative.")])]), _vm._v(" The result is a public inoculated against the church, Jesus, and faith.")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Together these four myths create a narrative of church failure and decline. Yet when we peel back the layers we discover that they are misleading or flat-out wrong. As we survey each myth, we will consider not only how it dominates common views of the church but how putting the truth into perspective can empower Christians to once again serve in their churches and engage society with boldness.")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-010"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Myth 1: America Is Becoming “a Nation of Nones”")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("As with any myth that people accept, there are echoes of truth that help to support the message. Recent data out of Pew Research, reflected in figure 2.1, highlights what this myth gets right.")]), _c('figure', {
    staticClass: "fig",
    attrs: {
      "id": "fig-004"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "Figure 2.1. Religious shifts between 2007 and 2014",
      "src": "images/fig_2_1_gray.jpg"
    }
  })]), _c('div', {
    staticClass: "fig_source"
  }, [_c('b', [_vm._v("Source:")]), _vm._v(" “5 Key Findings About the Changing U.S. Religious Landscape,” FactTank, Pew Research Center, May 12, 2015, "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://www.pewresearch.org/fact-tank/2015/05/12/5-key-findings-u-s-religious-landscape",
      "target": "_blank"
    }
  }, [_vm._v("www.pewresearch.org/fact-tank/2015/05/12/5-key-findings-u-s-religious-landscape/")])]), _c('figcaption', {
    staticClass: "leg"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("Figure 2.1. ")]), _vm._v("Religious shifts between 2007 and 2014")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_36",
      "title": "36"
    }
  }, [_vm._v("There are several central takeaways we can glean from this data. First, between 2007 and 2014 the number of Americans who identify as Christian has dropped seven percentage points (78 to 71)."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntf-037",
      "id": "ap_ntf-037-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" However, this data does not discriminate between nominal and committed Christians, and, as we will see later, this decline is overwhelmingly due to the former letting go of identification with Christian faith. Second, Catholics and mainline Protestants were hit particularly hard, with 3.1 percent and 3.4 percent declines, respectively. If this decline continues, one scholar estimates that mainline Protestantism has roughly twenty-three Easters left before complete collapse."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntf-038",
      "id": "ap_ntf-038-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" Finally, while fewer people identify as Christian, those identifying as religiously unaffiliated or “nones” has grown from 16 percent to 23 percent. This is a massive growth for only seven years, with millennials (ages eighteen to thirty-three in 2014) accounting for a significant portion of this shift (25 to 35 percent)."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntf-039",
      "id": "ap_ntf-039-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" Looking only at the unchurched, those who identified as nones has risen to just over one-third (34 percent), again with millennials accounting for a significant share of this growth (43 percent of unchurched millennials identify as nones)."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntf-040",
      "id": "ap_ntf-040-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" More critically, the percent of unchurched millennials who identify as nones "), _c('i', [_vm._v("equals")]), _vm._v(" the percent of unchurched millennials that identify as Christians. We have reached a tipping point.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Yet not all the news is bad. Digging deeper into the data uncovers several truths by which we can begin to sketch out a counternarrative that could empower more hope and more engagement. The most compelling of these is that Protestant evangelicals remain the largest religious group in America, surpassing nones and every other religious identification. Moreover, Protestant evangelicals have shown greater stability, with an increase in numbers, though a slight decrease in percentage of total population (-0.9 percent). In other words, the most evangelistically oriented wing of the Protestant church has remained stable, while significant losses have occurred in the least evangelistically oriented denominations.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_37",
      "title": "37"
    }
  }, [_vm._v("One way to assess how non-Christian America has become is to look at the percentages of the ranks of the unchurched. For our research, we defined an unchurched person as anyone who has "), _c('i', [_vm._v("not")]), _vm._v(" attended church (or synagogue, temple, or mosque, for that matter) in the last six months, except for a wedding, funeral, or special event (e.g., holiday service). It is a fluid group, with some having just stopped attending six months previously and others having been away for years.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("As of March 2016, there were "), _c('i', [_vm._v("143 million")]), _vm._v(" unchurched people (110 million, if we are just looking at adults) in the United States."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntf-041",
      "id": "ap_ntf-041-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" To put that number in perspective, if the unchurched formed their own country, it would be the tenth-largest nation on earth. That’s ahead of Mexico or Japan! When we put this number in context up against those who still attend church (whether regularly or intermittently) and those who have since left the church, we can see the significance of this block of Americans.")]), _c('figure', {
    staticClass: "fig",
    attrs: {
      "id": "fig-005"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "Figure 2.2. Church attendance profile for people in the United States",
      "src": "images/fig_2_2_gray.jpg"
    }
  })]), _c('div', {
    staticClass: "fig_source"
  }, [_c('b', [_vm._v("Source:")]), _vm._v(" “Unchurched Report,” Billy Graham Center Institute and Lifeway Research, January 5, 2017, "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://www.lifewayresearch.com/wp-content/uploads/2017/01/BGCE-Unchurched-Study-Final-Report-1_5_17.pdf",
      "target": "_blank"
    }
  }, [_vm._v("http://lifewayresearch.com/wp-content/uploads/2017/01/BGCE-Unchurched-Study-Final-Report-1_5_17.pdf")])]), _c('figcaption', {
    staticClass: "leg"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("Figure 2.2.")]), _vm._v(" Church attendance profile for people in the United States")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Notice in "), _c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/p1chap1#fig-005"
    }
  }, [_vm._v("figure 2.2")]), _vm._v(" that, as of January 2016, 55 percent of Americans are somewhat or very churched. This is the "), _c('i', [_vm._v("other ")]), _vm._v("side of the coin. "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_38",
      "title": "38"
    }
  }, [_vm._v("Even as the unchurched population has grown, the majority of Americans are "), _c('i', [_vm._v("still")]), _vm._v(" churchgoers. By “actively churched,” this study refers to those who attend more than once a month (about 45 percent), while the “marginally churched” are those who attended once a month or less. Thirty-four percent of Americans are dechurched, which means that they attended church regularly at some point in the past, either as a child, teen, or adult, but do so no longer. From the perspective of congregations, we had them once and we lost them. Finally, from our research, 11 percent are purely unchurched, having never regularly attended church at any time in their lives. In 2014, the Barna Group reported 10 percent as purely unchurched, so in the following two years this percentage has grown by about 1 percent."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntf-042",
      "id": "ap_ntf-042-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])])])]), _c('figure', {
    staticClass: "fig",
    attrs: {
      "id": "fig-006"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "Figure 2.3. Percentage of unchurched Americans",
      "src": "images/fig_2_3_gray.jpg"
    }
  })]), _c('div', {
    staticClass: "fig_source"
  }, [_c('b', [_vm._v("Source:")]), _vm._v(" George Barna and David Kinnaman, "), _c('i', [_vm._v("Churchless: Understanding Today’s Unchurched and How to Connect with Them")]), _vm._v(" (Carol Stream, IL: Tyndale House, 2014), viii; “Unchurched Report,” Billy Graham Center Institute and Lifeway Research, January 5, 2017, "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://www.lifewayresearch.com/wp-content/uploads/2017/01/BGCE-Unchurched-Study-Final-Report-1_5_17.pdf",
      "target": "_blank"
    }
  }, [_vm._v("http://lifewayresearch.com/wp-content/uploads/2017/01/BGCE-Unchurched-Study-Final-Report-1_5_17.pdf.")])]), _c('figcaption', {
    staticClass: "leg"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("Figure 2.3. ")]), _vm._v("Percentage of unchurched Americans")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("According to "), _c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/p1chap1#fig-006"
    }
  }, [_vm._v("figure 2.3")]), _vm._v(", not only are the unchurched a sizable demographic, but there is ample evidence that they have grown in the past generation. Beginning in the 1990s, only 30 percent of America was unchurched. While this grew slowly to one-third (33 percent) of Americans by the 2000s, it jumped to 43 percent by 2014 and again to 45 percent in 2016. This trend suggests that the unchurched percentage "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_39",
      "title": "39"
    }
  }, [_vm._v("is currently growing by about 1 percent per year. In other words, the train is picking up momentum, not losing it. There is cause for concern. But panic? Alarm? Cause for trumpeting the marginalization and non-Christianization of America? No!")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Let me offer three reasons why we shouldn’t panic. First, any panic loses sight of the fact that 70.6 percent of Americans still identify as Christians."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntf-043",
      "id": "ap_ntf-043-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" Even as the trend line is going down by about 1 percent a year over the past seven years, it will still take more than twenty years before the majority of Americans no longer identify as Christian. More to the point, the percent of actively churched people has been consistent over the last decade."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntf-044",
      "id": "ap_ntf-044-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" The loss is among people who used to identify as Christian but were not active.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The second reason the church should not be overly alarmed by the rise in unchurched Americans is that even among those unchurched, the majority still "), _c('i', [_vm._v("identify as Christian")]), _vm._v(". The black bars in "), _c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/p1chap1#fig-007"
    }
  }, [_vm._v("figure 2.4")]), _vm._v(" track the religious identification of "), _c('i', [_vm._v("unchurched ")]), _vm._v("people in America. According to our 2016 “Unchurched Report,” 56 percent of unchurched individuals identify as Christians and 32 percent identify as nones.")]), _c('figure', {
    staticClass: "fig",
    attrs: {
      "id": "fig-007"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "Figure 2.4. Americans’ religious preference",
      "src": "images/fig_2_4_gray.jpg"
    }
  })]), _c('div', {
    staticClass: "fig_source"
  }, [_c('b', [_vm._v("Source:")]), _vm._v(" “Unchurched Report,” Billy Graham Center Institute and Lifeway Research, January 5, 2017, "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://http://www.lifewayresearch.com/wp-content/uploads/2017/01/BGCE-Unchurched-Study-Final-Report-1_5_17.pdf",
      "target": "_blank"
    }
  }, [_vm._v("http://lifewayresearch.com/wp-content/uploads/2017/01/BGCE-Unchurched-Study-Final-Report-1_5_17.pdf")])]), _c('figcaption', {
    staticClass: "leg"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("Figure 2.4. ")]), _vm._v("Americans’ religious preference"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntf-045",
      "id": "ap_ntf-045-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_40",
      "title": "40"
    }
  }, [_vm._v("What about the growing trend of the increase of the nones? Nones include atheists and agnostics (together only 7 percent of the American population; 3 percent growth between 2007 and 2014) and “nothings in particular” (16 percent of all Americans— 4 percent growth between 2007 and 2014)."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntf-046",
      "id": "ap_ntf-046-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _vm._v(" But catch this. Nones are not necessarily irreligious, by which I mean disconnected from any established or organized form of religion, or unspiritual. Spirituality is often defined in fluid and loose terms as referring to a feeling of connectedness to something larger than oneself, and that connectedness can happen through experiences with friends, pets, food, mind-expanding drugs, nature, God, or in many other ways that combine mind, body, and spirit."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntf-047",
      "id": "ap_ntf-047-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])]), _vm._v(" Still, over two-thirds believe in God, 81 percent believe in a force or higher being that can be reached through prayer, most think churches benefit society by strengthening community bonds and aiding the poor, more than a third describe themselves as spiritual, and 20 percent pray daily."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntf-048",
      "id": "ap_ntf-048-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])]), _vm._v(" Even nones are more spiritual, religious, and receptive than we might expect.")])]), _c('figure', {
    staticClass: "fig",
    attrs: {
      "id": "fig-008"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "Figure 2.5. Number of evangelical Protestants, in millions, 2007–2014",
      "src": "images/fig_2_5_gray.jpg"
    }
  })]), _c('div', {
    staticClass: "fig_source"
  }, [_c('b', [_vm._v("Source:")]), _vm._v(" “Number of Protestants Growing,” Religion & Public Life, Pew Research Center, May 11, 2015, "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://www.pewforum.org/2015/05/12/americas-changing-religious-landscape/pf_15-05-05_rls2_evangelical200px-2",
      "target": "_blank"
    }
  }, [_vm._v("http://www.pewforum.org/2015/05/12/americas-changing-religious-landscape/pf_15-05-05_rls2_evangelical200px-2/")])]), _c('figcaption', {
    staticClass: "leg"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("Figure 2.5. ")]), _vm._v("Number of evangelical Protestants, in millions, 2007–2014")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_41",
      "title": "41"
    }
  }, [_vm._v("Third, as we can see in "), _c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/p1chap1#fig-008"
    }
  }, [_vm._v("figure 2.5")]), _vm._v(", the religiously committed are as religious or more religious than ever. While many are leaving faith, research indicates that those who are religiously committed, Christian or otherwise, are relatively stable or even growing. The decline in Christian identity, then, is the vast middle of the American population, those scholars typically identified as cultural or nominal Christians.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Tracing data from the General Social Survey over the past forty years, Ed Stetzer has argued, “The percentage of convictional Christians has remained relatively steady, with some decline.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntf-049",
      "id": "ap_ntf-049-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])]), _vm._v(" We are losing the nominal and cultural Christians, those who identify but do not practice or are not devout. As a result, we see that evangelicalism in America is actually "), _c('i', [_vm._v("growing")]), _vm._v(". As "), _c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/p1chap1#fig-008"
    }
  }, [_vm._v("figure 2.5")]), _vm._v(" demonstrates, even as religious nones have increased since 2007, evangelicals added 2.4 million to their numbers (not quite keeping up with population growth). Nondenominational churches continue to thrive and are the major success story in terms of rapid growth over the past few decades in America."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntf-050",
      "id": "ap_ntf-050-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The loss of the culturally and nominally religious Christians is not nearly as alarming and may even have positive implications for Christianity. One of the challenges faced by the advocates of Christian faith is making congregations countercultural enough to be truly vibrant, especially in any culture where those who identify as Christians are in the majority. People choosing to be either genuinely committed to Christian faith or else not identify at all clarifies what Christian faith looks like and forces people to make the choice. The loss in numbers but increase in vitality could be a huge plus for the future of Christian congregations in America.")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-011"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Myth 2: Millennials Are Forsaking the Church, Never to Return")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Over the last decade, we have seen a flurry of statistics that supposedly reveal a mass exodus of millennials from the church. Yet when we "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_42",
      "title": "42"
    }
  }, [_vm._v("examine these statistics and the broader narrative closely, it becomes fairly clear that these claims of alarm are exaggerations. One of these statistics, initially shared on a blog before being broadly circulated, reveals how this narrative can catch on quickly:")])]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("There is a well-known statistic that tells us that 80% of youth stop attending church after they graduate high school. As a parent, that’s the most horrifying statistic in the world to me! Let me bring that closer to home, that means, in a church youth group with 20 kids, over 15 will no longer go to church after they graduate. In a home, 3 out of 4 of our kids statistically will forsake fellowship by the time they’re 18. The cry of all of our hearts should be “why”?!"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntf-051",
      "id": "ap_ntf-051-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("This certainly paints a dire picture, but pushing past the sensationalism, discerning Christians always need to ask where a statistic comes from. The answer in this case: a gathering of some high school youth group leaders who guessed and averaged their guesses."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntf-052",
      "id": "ap_ntf-052-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _vm._v(" This is hardly a scientific and reliable method. For all of this alarm, what was the central takeaway? Buy a given book on evangelizing youth.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Another study purportedly found that 88 percent of the children in evangelical homes leave church at the age of eighteen, never to return."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntf-053",
      "id": "ap_ntf-053-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])]), _vm._v(" As it turns out, the only source for this statistic is an annual denominational report recommending radical steps to save families and youth in America. But no actual study was cited, no documentation given. Nevertheless, the stat circulated widely. Various other “studies” and researchers have claimed similar statistics, the worst proposing that 96 percent of American teenagers would leave the faith."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntf-054",
      "id": "ap_ntf-054-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])]), _vm._v(" Common to each example is its embrace of the Chicken Little Syndrome: fear-inducing arguments designed to sell books, but that also drive problematic or passive behavior.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The problem is that this attitude is addictive, generating a sense of urgency by injecting panic into the discussion rather than thoughtfully "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_43",
      "title": "43"
    }
  }, [_vm._v("considering how the church should respond. In his article “Curing Christians’ Stats Abuse,” Ed Stetzer helpfully explains how this attitude is counterproductive to Christian mission and outreach. Nothing generates buzz around a book or a conference like statistics that strike fear into the hearts of readers or attendees. Armed with exaggerated or false stats,")])]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("an advertisement for a summit . . . declared, “Christianity in America won’t survive another decade unless we do something now.” The summit organizers claimed that only 4 percent of today’s teenagers would be evangelical believers by the time they became adults. “We are on the verge of a catastrophe!” the advertisement screamed."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntf-055",
      "id": "ap_ntf-055-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("As Stetzer details, the advertisement then markets the book or summit as the silver bullet that can turn the tide.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("It turns out that the source of this distorted statistic was an informal survey of 211 young people conducted in the mid-1990s and spanning only three states."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntf-056",
      "id": "ap_ntf-056-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])]), _vm._v(" This is clearly not a representative sample. As Stetzer summarizes, we cannot draw such “an unwarranted inference . . . from a small, non-representative sample to reach conclusions about the future faith conditions of entire generations!”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntf-057",
      "id": "ap_ntf-057-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])]), _vm._v(" Especially when the unrepresentative sample is contradicted by a number of much more representative samples, including the sample in our current research project.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The sad truth is that these statistics that provoke Chicken Little Syndrome sell books and conferences. It is largely why they get used, circulated, and become part of the negative narrative. Over time, as they are repeated in publications and from leaders at summits, these questionable statistics become the dominant narrative. In only a few short steps, they move from blog to believable to broadly viral.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("What are the actual figures for high school dropouts? A report by Lifeway Research explains that “66 percent of young adults ages 23-30 "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_44",
      "title": "44"
    }
  }, [_vm._v("stopped attending church regularly for at least a year between ages 18-22.” The report goes on to say that “among church dropouts who are now ages 23-30, 31 percent, or about a third, currently attend church twice a month or more.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntf-058",
      "id": "ap_ntf-058-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])]), _vm._v(" So the loss rate is more like 46 percent for Protestant churches. That is alarming enough without putting it on steroids and claiming 96 percent.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("More to the point, there is actual evidence to be hopeful for Christians reaching young adults. With the problematic parts of this myth exposed, in the "), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/p1chap3#chap-003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("next chapter")]), _vm._v(" we can focus on what the true statistics tell us about the receptivity of young adults and how churches are successfully reaching them today.")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-012"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Myth 3: The Church Is Dwindling in America and Will Disappear in a Generation")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("This myth has proven especially popular among pastors and missiologists. In fact, in my first book, "), _c('i', [_vm._v("Evangelism Outside the Box")]), _vm._v(", I touch on this idea in trying to exhort Christians to see the unchurched as a harvest ripe for evangelism. At that point, as now, I was hopeful that by changing our approach to evangelism and outreach we might better engage a shifting culture.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Yet where I suggested we had an opportunity, others have been quick to emphasize alarm or pessimism. Two quotes from influential missional books perfectly capture this message: the church as we know it is nearing extinction.")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea retrait_autre"
  }, [_vm._v("The church in America is in big trouble. We’re on the endangered species list."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntf-059",
      "id": "ap_ntf-059-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])])]), _c('p', {
    staticClass: "txt_courant_justif last retrait_autre"
  }, [_vm._v("It is our belief that one of the core tasks of missional leadership is to assist the church to find new forms and expressions of church or bear the responsibility of the church’s effective extinction in our day."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntf-060",
      "id": "ap_ntf-060-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_45",
      "title": "45"
    }
  }, [_vm._v("The second quote comes from an Australian church context but has been widely embraced in the American context as well.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I should also say that current missiologists such as Alan Hirsch, Michael Frost, and Lance Ford are good friends, highly respected colleagues, and profound thinkers about the church. But I want to balance their tendency (and mine) to overstate the crisis and the impending extinction for the church, which at this point in time they might want to balance as well. For instance, Alan Hirsch had a tendency to be critical of nondenominational megachurches from his Australian home but now works with many such congregations. Nevertheless, as a prophetic voice, he often also has to fight disillusionment, as do we all.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("So is the American church on its last legs, nearing effective extinction? Not even remotely. Fifty-five percent of Americans attend a church, synagogue or mosque,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntf-061",
      "id": "ap_ntf-061-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])]), _vm._v(" and 51 percent do so at least once a month."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntf-062",
      "id": "ap_ntf-062-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])]), _vm._v(" Millennials leave church at high levels during their eighteen- to twenty-four-year-old period,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntf-063",
      "id": "ap_ntf-063-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])]), _vm._v(" but they return to church at a rate that is consistent with earlier generations between twenty-five and thirty-four."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntf-064",
      "id": "ap_ntf-064-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The church in America in particular and religious institutions in America in general have not disappeared in three hundred years and are not likely to any time soon. And whether the church declines steeply is more dependent on the quality of the church’s life and witness than on the shifts in American culture. I will unpack that point more in "), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/p1chap4#chap-004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter three")]), _vm._v(".")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-013"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Myth 4: Trust in the Church Is at an All-Time Low, and Past Experiences Are Largely Negative")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("One striking characteristic of the unchurched is that many have some significant background with the church, and two-thirds are not interested in returning.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("According to our 2016 “Unchurched Report,” only 25 percent of the unchurched were never churched. That 25 percent of all unchurched "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_46",
      "title": "46"
    }
  }, [_vm._v("translates to 11 percent of all Americans who have never attended church regularly. For 75 percent of the unchurched, we had them once, and we lost them.")])]), _c('figure', {
    staticClass: "fig",
    attrs: {
      "id": "fig-009"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "Figure 2.6. Unchurched response to “Have you ever regularly attended a Christian church?”",
      "src": "images/fig_2_6_gray.jpg"
    }
  })]), _c('div', {
    staticClass: "fig_source"
  }, [_c('b', [_vm._v("Source:")]), _vm._v(" “Unchurched Report,” Billy Graham Center Institute and Lifeway Research, January 5, 2017, "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://www.lifewayresearch.com/wp-content/uploads/2017/01/BGCE-Unchurched-Study-Final-Report-1_5_17.pdf",
      "target": "_blank"
    }
  }, [_vm._v("http://lifewayresearch.com/wp-content/uploads/2017/01/BGCE-Unchurched-Study-Final-Report-1_5_17.pdf")])]), _c('figcaption', {
    staticClass: "leg"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("Figure 2.6. ")]), _vm._v("Unchurched response to “Have you ever regularly attended a Christian church?”")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Why did they leave? People cite many reasons, but three stand out above the rest.")]), _c('figure', {
    staticClass: "fig",
    attrs: {
      "id": "fig-010"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "Figure 2.7. Top three reasons unchurched have stopped attending church",
      "src": "images/fig_2_7_gray.jpg"
    }
  })]), _c('div', {
    staticClass: "fig_source"
  }, [_c('b', [_vm._v("Source:")]), _vm._v(" “Unchurched Report,” Billy Graham Center Institute and Lifeway Research, January 5, 2017, "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://www.lifewayresearch.com/wp-content/uploads/2017/01/BGCE-Unchurched-Study-Final-Report-1_5_17.pdf",
      "target": "_blank"
    }
  }, [_vm._v("http://lifewayresearch.com/wp-content/uploads/2017/01/BGCE-Unchurched-Study-Final-Report-1_5_17.pdf")]), _vm._v(". This percentage was determined from a factor analysis conducted by the Billy Graham Center Institute, which revealed these groupings of reasons.")]), _c('figcaption', {
    staticClass: "leg"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("Figure 2.7. ")]), _vm._v("Top three reasons unchurched have stopped attending church")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_47",
      "title": "47"
    }
  }, [_vm._v("Though the top reason was a loss of trust, notice that only 35 percent of the unchurched cite that reason. About a third of the people who used to attend church and now do not lost trust in God, the church, or Christians. That reality is not to be taken lightly, but it is also not to be amplified and made to sound as if it applies to most Americans. It does not. Sometimes the church gets a bad rap, and sometimes the church deserves it, but the stats are not as adverse and serious as we have often been led to believe by alarmist news articles and spurious stats.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("What’s more, only 5 percent of unchurched individuals lost trust "), _c('i', [_vm._v("in God")]), _vm._v(" because of a negative experience in their lives for which they felt God was somehow responsible."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntf-065",
      "id": "ap_ntf-065-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])]), _vm._v(" In other words, despite having broken trust with the church, these individuals may still be very open to God and to faith. They just are not as open to Christians and congregations. Most of the 35 percent lost trust in a Christian or a church because of a bad experience. All these people are not necessarily gone for good. Many of the previously unchurched people we talked to had left the church due to broken trust but then returned after trust had been rebuilt. I think of Tina, who went to church as a kid but stopped because she felt judged for becoming pregnant in high school."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntf-066",
      "id": "ap_ntf-066-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])]), _vm._v(" She visited a different church but felt like the church was always asking for money. At that point in life, she still believed in God, but she had trust issues with church and church people, and she felt she could still have God without needing to attend church.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Then she met a church member passing out fliers for an event that she thought would be good for her daughter. So she went with her daughter, who liked the experience. Tina went back. She kept going back. The hospitality of the congregants and the level of acceptance of Tina as a single mom rebuilt broken trust and brought a “done” who had left because of trust issues back to church, back to God, and back to optimism about her life and her capacity to contribute. Hospitality and acceptance kept her coming back.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_48",
      "title": "48"
    }
  }, [_vm._v("Rebuilding broken trust is always the necessary first step for people with broken trust. But broken trust is healable.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("What’s more, broken trust is not the norm for most of the unchurched. Most who exited left not because they lost trust but because they felt church was irrelevant or their life circumstances changed. One of the major reasons emerging adults, people between the ages of nineteen and twenty-nine, leave church is that they leave their family of origin and don’t reengage in church elsewhere. Their life circumstances change. Or, as Rodney Stark puts it, “Having left home, many single young adults choose to sleep in on Sunday mornings.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntf-067",
      "id": "ap_ntf-067-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])]), _vm._v(" That could become fixable as emerging adults grow older.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Others leave just because they did not find anything compelling enough to stay (30 percent of those who left told us this was their primary reason for leaving). Howard Hendricks used to say, “It is a sin to bore a kid in church.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntf-068",
      "id": "ap_ntf-068-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])]), _vm._v(" I think it is not just kids who are hurt by being subjected to services that stimulate sleepiness and boredom and feel irrelevant. One reason so many nondenominational churches have grown so rapidly is that their leaders and pastors have focused on how to engage people on issues that are relevant and compelling in their lives.")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-014"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Building a New Narrative")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("These myths have been central to the narrative that the church is dying in America. While they have caused significant panic and alarm, the data suggests that the picture they generate is either exaggerated or flat-out wrong. Let me quickly recap where these myths fail:")]), _c('ul', {
    staticClass: "liste_puce"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_c('i', [_vm._v("Myth 1: America is not becoming non-Christian, “a nation of nones.”")]), _vm._v(" In reality, the majority of the people in America still identify as Christian and probably will for about another twenty years. Even among the unchurched, those who identify as Christian are still a majority. While nones are on the rise, "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_49",
      "title": "49"
    }
  }, [_vm._v("this stat lumps together receptive people with those hostile toward Christianity.")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_c('i', [_vm._v("Myth 2: Millennials are not leaving the church at the high rate that we have heard but rather at a rate of about 45 percent.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntf-069",
      "id": "ap_ntf-069-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")])]), _vm._v(" Although deeply concerning, this is not as different from past generations at the same age as we might think."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntf-070",
      "id": "ap_ntf-070-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])]), _vm._v(" Faith remains far more relevant to the emerging generation than we have been led to believe.")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_c('i', [_vm._v("Myth 3: The church will not be extinct in America in a generation.")]), _vm._v(" Although nominal Christianity may be fairly dead in a generation, the ranks of the committed remain relatively stable.")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_c('i', [_vm._v("Myth 4: Some of the unchurched in America have serious trust issues with the church (35 percent of those who left), but many more (65 percent of those who left) do not indicate broken trust as the main reason they left. ")]), _vm._v("Most unchurched individuals either never found a compelling reason to stay or else simply had a change in life circumstances that ended their involvement. As we will see in the "), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/p1chap2#chap-002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("next chapter")]), _vm._v(", many of the unchurched have a much more positive view of the church than we would expect.")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("These four myths together have helped reinforce a false narrative about receptivity in American culture. Many of us have embraced this false narrative, and we need to nuance it in some cases and shed it entirely in others. At the end of the day, the main problem with the church reaching new people, developing reproducers who advocate for faith and invite others into congregations, and then influencing communities for good is . . . the church! The biggest challenge congregations need to overcome is our own mindset and not the hostility or apathy of the larger culture. We need a new and better narrative that more accurately reflects the reality of the attitudes of the unchurched toward congregations, Christian faith, and spiritual conversation. "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_50",
      "title": "50"
    }
  }, [_vm._v("And we need better and more culturally sensitive and effective ways of capitalizing on the receptivity that is there.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("What is the new narrative? What are the attitudes of the unchurched to the church and the Christian faith? How can congregations approach the unchurched and irreligious effectively in America today? Let’s turn to those questions next and begin constructing a new narrative that can better serve and ignite congregations in their mission.")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-015"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Questions for Discussion")]), _c('ol', {
    staticClass: "liste_num_point"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_c('span', {
    staticClass: "symbol_type_num"
  }, [_vm._v("1")]), _c('span', {
    staticClass: "symbol_point"
  }, [_vm._v(".")]), _vm._v(" Rick mentions four myths that are widely promoted in the press and among Christians:")]), _c('ul', {
    staticClass: "liste_puce"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("America is becoming a “nation of nones”")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("Millennials are forsaking the church, never to return")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("The church is dwindling in America and will disappear in a generation")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("Trust in the church is at an all-time low, and experiences are largely negative")]), _c('p', {
    staticClass: "liste_txt_courant_ssalinea"
  }, [_vm._v("Which of these myths have you heard or believed, and how have they affected you?")])])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_c('span', {
    staticClass: "symbol_type_num"
  }, [_vm._v("2")]), _c('span', {
    staticClass: "symbol_point"
  }, [_vm._v(".")]), _vm._v(" What did you learn in the chapter to help counteract the negative impact of these myths?")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_c('span', {
    staticClass: "symbol_type_num"
  }, [_vm._v("3")]), _c('span', {
    staticClass: "symbol_point"
  }, [_vm._v(".")]), _vm._v(" What one thing in the chapter most encourages you to have missional imagination?")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09c64d8c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/p1chap1.vue
// module id = 75
// module chunks = 0